export enum ActionTypes {
  FETCH_USER = 'FETCH_USER',
  SESSION_LOGIN = 'SESSION_LOGIN',
  AD_LOGIN = 'AD_LOGIN',
  LOGOUT = 'LOGOUT',
}
